/**
 * Known potential responses from the remote API.
 *
 * https://haveibeenpwned.com/API/v2#PwnedPasswords
 *
 */
/** @internal */
var OK = {
    status: 200
};
/** @internal */
var BAD_REQUEST = {
    status: 400,
    data: 'The hash prefix was not in a valid format'
};

export { BAD_REQUEST, OK };
//# sourceMappingURL=responses2.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/responses2.js
// module id = ./node_modules/hibp/es/responses2.js
// module chunks = 2